import React from 'react';
import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';
import Checkbox from 'relements/build/esm/input/checkbox';
import { Container as Card } from '@src/components/ToolCard/styledComponents';
import LoadingState from './LoadingState';

const commonProps = {
  padding: 'zero',
  marginY: 'lg',
  flexWrap: 'wrap',
};

const Departments = ({ departments, setSelection, selectedDept, loading }) => {
  const updateSelectedDept = (deptName) => {
    const deptValues = [...selectedDept];
    if (deptValues.includes(deptName)) {
      const index = deptValues.indexOf(deptName);
      deptValues.splice(index, 1);
    } else {
      deptValues.push(deptName);
    }
    setSelection('departments', deptValues);
  };
  return (
    <>
      <Text variants="body.md" color="haptik.black">
        Select the departments you want to associate your bot with
      </Text>
      {loading ? (
        <LoadingState />
      ) : (
        <Box {...commonProps} flexDirection="column">
          {departments.map((dept) => (
            <Box width="300px">
              <Card>
                <Text variants="h3.semi-bold">
                  <Checkbox.Item
                    themed
                    label={Object.values(dept)}
                    value={selectedDept.includes(Object.keys(dept)[0])}
                    onChange={() => updateSelectedDept(Object.keys(dept)[0])}
                  />
                </Text>
              </Card>
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};

export default Departments;
